<template>
    <div v-if="list.length" class="DshIcons">
        <Icon
            v-for="(operationItem, index) in list"
            :key="operationItem.icon"
            :style="operationItem.style"
            :class="['DshIcons-item', index ? 'dsh-margin-left5' : undefined, itemClass, operationItem.class]"
            :title="operationItem.name"
            :type="operationItem.custom ? undefined : operationItem.icon"
            :custom="operationItem.custom ? `bico-font ${operationItem.icon}` : undefined"
            :color="operationItem.color"
            :size="typeof parseInt(operationItem.size) === 'number' && parseInt(operationItem.size) || 18"
            @click.stop="click(operationItem, index)"
        />
    </div>
</template>

<script>
    export default {
        name: "DshIcons",
        props: {
            list: {
                type: Array,
                default () {
                    return [];
                }
            },
            itemClass: String
        },
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {
            click (...params) {
                this.$emit("click", ...params);
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshIcons {
        display: inline-block;
        &-item {
            cursor: pointer;
        }
    }
</style>
<style lang="less">
    .DshIcons {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshIcons.vue